import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '二级分类',
    auth: true,
    authorityValue: "store-store-subcate"
  },
  name: 'trade-two-list',
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.data_bind(this.$route.query);
  },
  methods: {
    data_bind: function data_bind(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, total, records;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.storeGoodsTypes(_objectSpread({}, data));

              case 2:
                res = _context.sent;
                total = res.total, records = res.records;
                _this.total = total;
                _this.tableData = records;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pagination: function pagination(item) {
      this.data_bind(item);
    },
    handleNav: function handleNav(NAME, row) {
      this.$router.push({
        name: NAME,
        query: row ? row : ''
      });
    },
    deleteStoreGoodsType: function deleteStoreGoodsType(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$confirm('确认删除么？', '提示').then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                    var goodsTypeId;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            goodsTypeId = row.goodsTypeId;
                            _context2.next = 3;
                            return _this2.$api.deleteStoreGoodsType({
                              goodsTypeId: goodsTypeId
                            });

                          case 3:
                            _this2.$notify.success({
                              title: '成功',
                              message: '成功删除'
                            });

                            _this2.data_bind(_this2.$route.query);

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};